import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorCommunityScale from "@travily/types/pages/FoundingMemberCreatorCommunityScale";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ScaleStepView } from "./show.view";

type FormData = {
  community_profile: {
    hubs_operated: number;
  };
};

const FIELD = "community_profile.hubs_operated";

const ScaleStep = ({ stage_index, stage_order, community_profile }: FoundingMemberCreatorCommunityScale) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("community", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "scale",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { community_profile: { hubs_operated: community_profile.hubs_operated ?? 1 } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.community.scale.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.community.scale.show.meta_description")}
        />
      </Head>
      <ScaleStepView
        currentStage={currentStage}
        error={error}
        onBack={onBack}
        onPrimary={onPrimary}
        onValueChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        totalStages={totalStages}
        value={form.data.community_profile.hubs_operated}
      />
    </>
  );
};

export default ScaleStep;
